// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__2phPq","password":"PasswordResetForm_password__KO5AQ"};